import { ref, watch, computed, onUnmounted } from '@vue/composition-api'
import store from '@/store'
import useGroupEdit from '@/views/modules/group/groups-edit/useGroupEdit'
import groupStoreModule from '@/views/modules/group/store/groupStoreModule'
import { useUtils } from '@core/libs/i18n'
                
                


export default function useGroupsList(root) {
  const { t } = useUtils()

  const GROUP_S = 'groups'

  // Register module
  if (!store.hasModule(GROUP_S))
    store.registerModule(GROUP_S, groupStoreModule)

  // UnRegister on leave
  onUnmounted(() => {
    if (store.hasModule(GROUP_S))
      store.unregisterModule(GROUP_S)
  })


  const refGroupListTable = ref(null)

  const { toaster } = useGroupEdit(root)

  // Table Handlers
  const tableColumns = [
    { key: 'name', sortable: false, label: t('Name')},
    { key: 'contract', sortable: false, label: t('Contract')},
    { key: 'actions',label:t('actions') },
  ]

  const perPage = ref(10)
  const totalGroups = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [5, 10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)

  const requestStatus = ref(false)

  const dataMeta = computed(() => {

    const localItemsCount = refGroupListTable.value ? refGroupListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalGroups.value,
    }
  })

  const refetchData = () => {
    refGroupListTable.value.refresh()
  }

  const filter = ref({})

  watch([currentPage, perPage, searchQuery ], () => {

    filter.value = {
      ...(searchQuery.value && {q: searchQuery.value})
    }

    refetchData()

  })

  const contractsOptions = ref([]);

  store.dispatch('groups/fetchContractsOptions', {
    user: store.state.auth.userData.id,
    type: 'contract'
  }).then(response => {
    contractsOptions.value = response.data.data
  }).catch(reason => {})


  const fetchGroups = (ctx, callback) => {

    requestStatus.value = true
    store
      .dispatch('groups/fetchGroups', {
        length: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        ...filter.value
      })
      .then(response => {
        requestStatus.value = false
        const { data } = response.data.groups
        const { total } = response.data.groups?.meta

        callback(data)
        totalGroups.value = total
      })
      .catch(e => {
        requestStatus.value = false
        console.log(e)
      })
  }


  const removeGroup = (id) => {

    root.$swal({
      title: root.$i18n.t("Are You Sure"),
      text: root.$i18n.t("Do you want to delete this group?"),
      showCancelButton: true,
      confirmButtonText: root.$i18n.t('Delete'),
      customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-outline-danger ml-1',
      },
      buttonsStyling: false,
    }).then(result => {
      if (result.value) {
        requestStatus.value = true
        store.dispatch('groups/deleteGroup', id)
          .then(_ => {
            toaster('Group Deleted Successfully')
            refetchData()
          })
          .catch(reason => console.log(reason))
      }
    })
  }




  return {

    fetchGroups,
    tableColumns,

    perPage,
    currentPage,
    totalGroups,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refGroupListTable,
    removeGroup,
    requestStatus,
    refetchData,

    contractsOptions

  }
}
